module.exports = __webpack_public_path__ + "img/std-graz.20e93552.png";